import { useState } from "react";
import { useToolOpener } from "@/lib/dockBus";
import { useLocation } from "react-router-dom";
import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

export const FeedbackButton = () => {
  const [open, setOpen] = useState(false);
  useToolOpener("feedback", () => setOpen(true));
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const location = useLocation();

  const submit = async () => {
    if (!message.trim()) return;
    try {
      await api.post("/feedback", { page: location.pathname, message, email });
      toast.success("Thank you — we'll use this to make Pula easier.");
      setMessage(""); setEmail(""); setOpen(false);
    } catch {
      toast.error("Could not send just now. Please try again.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="feedback-button" data-simple-hide="true"
          className="fixed bottom-6 left-6 z-40 flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-[var(--pula-border)] shadow-md text-sm font-medium text-pula-ink hover:bg-pula-bg2 transition-colors">
          <ThumbsUp className="w-4 h-4 text-pula-green" /> Make this easier
        </button>
      </DialogTrigger>
      <DialogContent data-testid="feedback-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Help us make this easier</DialogTitle>
          <DialogDescription>Your note goes straight to our team.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-pula-inksoft font-body">Tell us what felt hard or confusing on this page. It goes straight to our team.</p>
        <Textarea data-testid="feedback-message" value={message} onChange={(e) => setMessage(e.target.value)}
          placeholder="What could be simpler?" rows={4} />
        <Input data-testid="feedback-email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email (optional)" type="email" />
        <Button data-testid="feedback-submit" onClick={submit} className="bg-pula-green hover:bg-pula-greenhover text-white">
          Send feedback
        </Button>
      </DialogContent>
    </Dialog>
  );
};
